import React from "react";
import { objectValues } from "../../../../utils";
import DisplayField from "../DisplayField";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import styles from "./DeliveryEvent.css";

function getPurchaseOrderJobs(purchaseOrder) {
  const jobsById = purchaseOrder.items
    .filter((p) => !!p.job)
    .reduce((jobs, p) => {
      const updatedJobs = Object.assign({}, jobs);
      updatedJobs[p.job.id] = p.job;
      return updatedJobs;
    }, {});
  return objectValues(jobsById);
}

const Details = ({ event }) => {
  const purchaseOrder = event.purchaseOrder || event.inventoryPurchaseOrder;
  return (
    <div>
      <DisplayField group="details" field="deliveryStatus">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Status
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {typeof purchaseOrder.status === "string"
              ? purchaseOrder.status
              : purchaseOrder.status?.name}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>

      <DisplayField group="details" field="supplier">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Supplier
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {purchaseOrder.supplier ? purchaseOrder.supplier.name : "N/A"}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>

      {purchaseOrder.items.some((p) => !!p.job) && (
        <DisplayField group="details" field="deliveryJobs">
          <FormGroup className={styles.dataValuePair}>
            <ControlLabel className={styles.dataValuePairLabel}>
              Jobs
            </ControlLabel>
            <FormControl.Static
              className={styles.dataValuePairValue}
              componentClass={"div"}
            >
              {getPurchaseOrderJobs(purchaseOrder).map((j) => (
                <div key={j.id}>
                  - {j.jobNumber} - {j.name}
                </div>
              ))}
            </FormControl.Static>
          </FormGroup>
        </DisplayField>
      )}
    </div>
  );
};

export default Details;
